export const environment = {
  googleAnalyticsKey: "UA-85020541-1",
  title: "Technomad",
  description:
    "Portail vers les différentes entités Technomad : Collectif Technomad | Technomad Audio",
};
